<template>
  <v-container>
    <PageHeader no-padding />
    <!-- <data-set-navigation-status :hasFilter="hasFilter" @clearFilters="onClearFilters()" /> -->
    <v-layout row wrap justify-space-around>
      <v-layout justify-space-around fill-height wrap>    
        <v-flex xs12 sm12 md12 pt-2 pl-2>
          <recycle-data-set-table @addFile="showAddFileDialog" v-bind:files="filteredFiles" :loading="files.isLoading" :totalItems="totalItems" :searchLoading ="searchLoading" v-model="pagination" />
        </v-flex>
      </v-layout>
    </v-layout>
    
    <v-card color="grey lighten-4">
      <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
        {{ snackMessage }}
        <v-btn dark flat @click.native.stop.prevent="snackbar = false">{{ $t('Button.Close') }}</v-btn>
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
  import PageHeader from '@/components/generic/PageHeader'
  import {
    createNamespacedHelpers,
  } from 'vuex'

  
  import DataSetNavigation from './DataSetNavigation'
  import DataSetNavigationStatus from './DataSetNavigationStatus'
  import RecycleDataSetTable from './RecycleBin/RecycleDataSetTable'

  import {
    filterTypes,
  } from '@/store/datasetfilter'
  import {
    FileNameFilter,
    MetadataMatchValuesFilter,
    MetadataMatchRangeFilter,
    StationCategoryFilter,
    LocationFilter,
    TimeFilter,
  } from '@/components/plugins/DataSetFilter'
  import {
    backendDateTimeFormat,
    formatDate,
  } from '@/components/mixins/MomentUtil'
  const app = createNamespacedHelpers('app')
  const authenticate = createNamespacedHelpers('authenticate')
  const rawdatarepository = createNamespacedHelpers('rawdatarepository')
  const datasetfilter = createNamespacedHelpers('datasetfilter')

  export default {
    name: 'datasets',
    components: {      
      DataSetNavigation,
      DataSetNavigationStatus,
      RecycleDataSetTable,
      PageHeader,
    },
    data() {
      return {
        addFileDialog: false,
        snackbar: false,
        snackColor: '',
        snackMessage: '',
        pagination: {
          descending: true,
          sortBy: 'DateCreated',
          rowsPerPage: 5,
          offset: 0,
          page: 1,
        },
        searchLoading: false,
        postOptions: {},
        unPushState: false,
      }
    },
    computed: {
      ...authenticate.mapGetters(['isTenantAdmin']),
      ...rawdatarepository.mapGetters(['files']),
      ...datasetfilter.mapGetters([
        'hasFilter',
        'getFilter',
        'allFilters',
        'getSubmittedFilters',
      ]),
      totalItems() {
        return this.files ? this.files.totalLength || 100 : 100
      },
      filterTypes() {
        return filterTypes
      },
      filteredFiles() {
        let that = this
        return that.files.data
      },
    },
    watch: {
      hasFilter: {
        handler: function(v) {
          if (!v) {
            // If hasFilter is set to false, clear submittedFilters and fetchFiles
            this.onClearFilters()
          }
        },
      },
      pagination() {
        this.fetchFiles({
          forced: true,
        })
      },
    },
    mounted() {
      this.fetchMetadataSchemas()
      var that = this
      window.addEventListener('popstate', that.onBackOrForward)
      this.unPushState = true
      this.oneTimeSetUpGetFiles()
    },
    beforeDestroy() {
      var that = this
      window.removeEventListener('popstate', that.onBackOrForward)
    },
    methods: {
      ...app.mapActions(['setSnackbar']),
      ...rawdatarepository.mapActions(['getRecycledFiles', 'getMetadataSchemas']),
      ...datasetfilter.mapActions(['clearFilters', 'submitFilters', 'updateFilterListByType', 'addFilter']),
      ...datasetfilter.mapMutations({
        setFilterViewModel: 'SetFilterViewModel',
      }),
      onBackOrForward() {        
        this.unPushState = true
        this.oneTimeSetUpGetFiles()
      },
      afterFilterChange() {
        if(this.pagination.page != 1 || this.pagination.offset != 0) {
          let temp = this.pagination
          temp.page = 1
          temp.offset = 0
          this.pagination = temp
        }
        this.fetchFiles({
          forced: true,
        })
      },
      onFilterSubmit() {
        let that = this
        let options = {
          successCb: () => {
            that.afterFilterChange()
          },
          failedCb: msg => {
            console.error(msg)
            that.setSnackbar({
              color: 'error',
              text: msg,
            })
          },
        }
        this.submitFilters(options)
      },
      onClearFilters() {
        let that = this
        let options = {
          successCb: () => {
            that.afterFilterChange()
          },
          failedCb: msg => {
            console.error(msg)
            that.setSnackbar({
              color: 'error',
              text: msg,
            })
          },
        }
        this.clearFilters(options)
      },
      fetchFiles({
        descending,
        sortBy,
        limit,
        offset,
        forced,
      }, data) {
        let that = this
        let options = {
          successCb: () => {
            this.searchLoading = false
            this.unPushState = false
          },
          failedCb: msg => {
            this.searchLoading = false
            console.error(msg)
            that.setSnackbar({
              color: 'error',
              text: msg,
            })
          },
          forced: forced || false,
          data: data || this.getSubmittedFilters,
        }

        options.config = {
          params: {
            descending: descending || this.pagination.descending,
            sortBy: sortBy || this.pagination.sortBy,
            limit: limit || this.pagination.rowsPerPage,
            offset: offset || this.pagination.offset,
            page: this.pagination.page,
          },
        }

        var filter = {
          config: options.config,
          forced: options.forced,
          data: options.data,
        }
        var filterJSON = JSON.stringify(filter)
        if(!this.searchLoading || filterJSON != this.postOptions) {
          this.searchLoading = true
          this.postOptions = filterJSON
          var newUrl = location.pathname + '?filter=' + encodeURIComponent(window.btoa(filterJSON))
          if(!this.unPushState) {
            history.pushState('', '', newUrl)
          }
          this.getRecycledFiles(options)
        }
      },
      showAddFileDialog() {
        this.addFileDialog = !this.addFileDialog
      },
      oneTimeSetUpGetFiles() {
        var json = location.search.substr(8)
        if(json) {
          var query = JSON.parse(window.atob(decodeURIComponent(json)))
          this.setFilterViewModel(query.data)
          this.setFilter(query.data)
          var newPagination = {
            descending: query.config.params.descending,
            sortBy: query.config.params.sortBy,
            rowsPerPage: query.config.params.limit,
            offset: (query.config.params.page - 1) * query.config.params.limit,
            page: query.config.params.page,
          }
          if(JSON.stringify(this.pagination) != JSON.stringify(newPagination)) {
            this.pagination = newPagination
          } else {
            this.fetchFiles({
              forced: true,
            })
          }
        } else {
          this.fetchFiles({
            forced: true,
          })
        }
      },

      setFilter(data) {
        let options = {
          successCb: () => {
            this.addFilters(data)
            let option = {
              successCb: () => {},
              failedCb: msg => {
                console.error(msg)
              },
            }
            this.submitFilters(option)
          },
          failedCb: msg => {
            console.error(msg)
          },
        }
        this.clearFilters(options)
        
      },
      addFilters(data) {
        data['FileNameFilters'].forEach(element => {
          this.addFilter(new FileNameFilter(element))
        })
        data['MatchRangeFilters'].forEach(element => {
          let filter
          if (element.fieldType == 'DateTime') {
            filter = new MetadataMatchRangeFilter(
              this.fieldName,
              this.fieldType,
              formatDate(this.dates.start, backendDateTimeFormat),
              formatDate(this.dates.end, backendDateTimeFormat),
            )
            this.addFilter(filter)
          }
        })
        data['MatchValuesFilters'].forEach(element => {
          let filter
          if(element.FieldType == 'MonitoringLocation') {
            let filterList = element.FieldValues.map(f => new LocationFilter(f))
            this.updateFilterListByType({
              filterType: 'location',
              filters: filterList,
            })
          } else if(element.FieldType == 'MonitoringComponent') {
            element.FieldValues.forEach(e => {
              this.addFilter(new StationCategoryFilter(e))
            })
          }
          else {
            element.FieldValues.forEach(e => {
              filter = new MetadataMatchValuesFilter(
                element.Field,
                element.FieldType,
                e
              )
              this.addFilter(filter)
            })
          }
        })
        data['TimeRangeFilters'].forEach(element => {
          let filter = new TimeFilter(new Date(element.StartDate), new Date(element.EndDate))
          this.addFilter(filter)
        })
      },
      fetchMetadataSchemas() {
        let options = {
          successCb: () => null,
          failedCb: err => {
            console.error(err)
            this.emitNotification(
              'error',
              'Error occurred fetching metadat schema'
            )
          },
        }
        this.getMetadataSchemas(options)
      },
    },
  }
</script>

<style lang="stylus" scoped>
  .toolbar__title.display-2 {
    padding-bottom: 10px;
    margin-left: 10px !important;
  }

  .v-progress-circular {
    margin-left: 1rem;
  }
</style>
